import { getFromStorage, saveToStorage } from '@klp/utils';

export class TwoFactorInfo {
    public static twoFactorAlertStatus = 'twoFactorAlertRead';

    public static hideTwoFactorAlert = () => {
        return saveToStorage(TwoFactorInfo.twoFactorAlertStatus, true);
    };

    public static getTwoFactorAlertReadStatus = () => {
        return getFromStorage(TwoFactorInfo.twoFactorAlertStatus);
    };
}
